import React, { useEffect } from 'react'

import { Container, ContentWrapper } from './styles'
import { TrackingSchemaTypes } from '../../tracking'
import { useTracking } from 'react-tracking'

interface BannerProps {
  banner: {
    large_image: string
    medium_image: string
    small_image: string
    link: string
    name: string
  }
}

const setSourceParam = (link: string) => {
  const url = new URL(link)
  if (!url.searchParams.get('source') || !url.searchParams.get('utm_source')) {
    url.searchParams.set('utm_source', 'Banner-Área-Aluno')
  }
  return url.toString()
}

const CampaignBanners: React.FC<BannerProps> = ({ banner }) => {
  const { trackEvent } = useTracking()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    trackEvent({
      event: TrackingSchemaTypes.BannerClick,
      properties: {
        Nome: banner.name,
      },
    })

    setTimeout(() => {
      window.open(setSourceParam(banner.link), '_blank')
    }, 200)
  }

  useEffect(() => {
    trackEvent({
      event: TrackingSchemaTypes.BannerImpression,
      properties: {
        Nome: banner.name,
      },
    })
  }, [banner, trackEvent])

  return (
    <Container>
      <ContentWrapper>
        <a
          href={setSourceParam(banner.link)}
          target="_blank"
          rel="noreferrer"
          onClick={handleClick}
        >
          <img src={banner.large_image} alt={banner.name} className="desktop" />
          <div>
            <img src={banner.medium_image} alt={banner.name} className="tablet" />
          </div>
          <div>
            <img src={banner.small_image} alt={banner.name} className="mobile" />
          </div>
        </a>
      </ContentWrapper>
    </Container>
  )
}

export default CampaignBanners
